import React from 'react';
import {
  Modal,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from '@mui/material';
import TargetHeartIcon from '../../Assets/images/target-heart.png';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%', // Mobile width
  maxWidth: 400, // Maximum width for larger screens
  bgcolor: 'white',
  border: '1px solid #ccc',
  borderRadius: 4,
  boxShadow: (theme) => theme.shadows[5],
  p: 4,
};

const HealthGoalModal = ({ open, onClose }) => {
  const [healthGoal, setHealthGoal] = React.useState('');
  const [age, setAge] = React.useState('');
  const [weight, setWeight] = React.useState('');
  const [medicalConcerns, setMedicalConcerns] = React.useState('');

  const handleHealthGoalChange = (event) => {
    setHealthGoal(event.target.value);
  };

  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };

  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  const handleMedicalConcernsChange = (event) => {
    setMedicalConcerns(event.target.value);
  };

  const handleUpdateRecords = () => {
    // Implement your logic to update records here
    console.log('Health Goal:', healthGoal);
    console.log('Age:', age);
    console.log('Weight:', weight);
    console.log('Medical Concerns:', medicalConcerns);
    onClose(); // Close the modal after updating
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="health-goal-modal-title"
      aria-describedby="health-goal-modal-description"
    >
      <Box sx={style} className="outline-none">
        <Box className="flex justify-center mb-4 text-green-500">
          <img src={TargetHeartIcon} sx={{ fontSize: 40 }} />
        </Box>
        <Typography id="health-goal-modal-title" variant="h6" component="h2" className="text-center mb-4 font-semibold text-gray-800">
          What's your health goal?
        </Typography>

        <FormControl fullWidth className="mb-4">
          <InputLabel id="health-goal-label" className="text-gray-600">Select your health goal</InputLabel>
          <Select
            labelId="health-goal-label"
            id="health-goal"
            value={healthGoal}
            onChange={handleHealthGoalChange}
            className="text-gray-700"
          >
            <MenuItem value="Low Sodium to improve heart conditions">Low Sodium to improve heart conditions</MenuItem>
            <MenuItem value="Lose Weight">Lose Weight</MenuItem>
            <MenuItem value="Improve Energy Levels">Improve Energy Levels</MenuItem>
            {/* Add more health goals as needed */}
          </Select>
        </FormControl>

        <Typography variant="subtitle1" className="mb-2 text-gray-700">
          Tell us more about your health goal.
        </Typography>

        <FormControl fullWidth className="mb-3">
          <TextField
            id="age"
            label="Age"
            type="number"
            value={age}
            onChange={handleAgeChange}
            className="text-gray-700"
          />
        </FormControl>

        <FormControl fullWidth className="mb-3">
          <TextField
            id="weight"
            label="Weight"
            type="number"
            value={weight}
            onChange={handleWeightChange}
            className="text-gray-700"
          />
        </FormControl>

        <FormControl fullWidth className="mb-4">
          <InputLabel id="medical-concerns-label" className="text-gray-600">Any known medical concerns</InputLabel>
          <Select
            labelId="medical-concerns-label"
            id="medical-concerns"
            value={medicalConcerns}
            onChange={handleMedicalConcernsChange}
            className="text-gray-700"
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="High Blood Pressure">High Blood Pressure</MenuItem>
            <MenuItem value="Diabetes">Diabetes</MenuItem>
            <MenuItem value="Allergies">Allergies</MenuItem>
            {/* Add more medical concerns as needed */}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          onClick={handleUpdateRecords}
          className="bg-green-500 hover:bg-green-700 text-white font-semibold rounded-md py-2 px-4 w-full"
        >
          Update Records
        </Button>
      </Box>
    </Modal>
  );
};

export default HealthGoalModal;